import { Injectable } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin, of } from 'rxjs';
import { concatMap, switchMap } from 'rxjs/operators';
import { Quake } from '../model/quake';
import { Region } from '../model/region';
import { Settings } from '../model/settings';
import { RegionService } from './region.service';
import { SettingsService } from './settings.service';

export interface StorageResult {
  lastUpdated: string;
  events: Quake[];
  settings: Settings;
  regions: Region[];
}


@Injectable({
  providedIn: 'root'
})
export class InitService {

  results: StorageResult;

  constructor(
    private storage: StorageMap,
    private settingsService: SettingsService,
    private regionService: RegionService,
    private translateService: TranslateService
  ) {

  }

  init(): Promise<any> {
    return firstValueFrom(forkJoin({
      lastUpdated: this.storage.get('lastUpdated'),
      events: this.storage.get('eventsWorld'),
      settings: this.storage.get('settings'),
      regions: this.regionService.init()
    }).pipe(
      switchMap((res: StorageResult) => {
        const baseMap = res.settings ? res.settings.baseMap : this.settingsService.settings.baseMap;
        res.regions.map(r => {
          r.asset = `assets/maps/${baseMap}/${r.asset}`
        });
        this.regionService.regions = res.regions;
        this.settingsService.init(res);
        console.log('Get translation files');
        return this.translateService.use(this.settingsService.settings.language);
      })
    ))
  }
}
